var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('LoadingSpinner'):_c('ProjectLeadList',{attrs:{"project":_vm.project,"users":_vm.users}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }